import React, { Component } from 'react';
import DevnagariKeyboard from 'devnagari-keyboard';

export class Counter extends Component {
  static displayName = Counter.name;

  constructor(props) {
    super(props);
    this.state = { currentCount: 0 };
    this.incrementCounter = this.incrementCounter.bind(this);
    }

  componentDidMount() {
      DevnagariKeyboard().AttachKeyConverter('txtQuery', true);
  }

  incrementCounter() {
    this.setState({
      currentCount: this.state.currentCount + 1
    });
    console.log('currentCount', this.state.currentCount) //Not immediately reflected untill component refresh
  }

  render() {
      return (
        <>
              <div className="mb-3">
                  <h3>Counter</h3>

                  <p>This is a simple example of a React component.</p>

                  <p aria-live="polite">Current count: <strong>{this.state.currentCount}</strong></p>

                  <button className="btn btn-primary" onClick={this.incrementCounter}>Increment</button>
              </div>
              <div className="mb-3">
                  <h3>Devnagari Script Typing Helper</h3>
                  <label for="message" className="form-label">You can use below textbox to phonetically write Hindi and Marathi words and sentences ad use them anywhere.</label>
                  <textarea class="form-control" id="txtQuery" rows="3" required></textarea>
              </div>
        </>
    );
  }
}
